import { render, staticRenderFns } from "./Titles.vue?vue&type=template&id=72cb8788&scoped=true&"
import script from "./Titles.vue?vue&type=script&lang=ts&"
export * from "./Titles.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72cb8788",
  null
  
)

export default component.exports